import { useReducer } from 'react';
import {
    type LabelsFilteringField,
    LabelsSortingField,
    type LabelsSortingRule,
    SortingOrder,
} from '../../../api/types';
import {
    type ExtendedPageState,
    type ExtendedPageAction,
    extendedReducer,
} from '../../../components/PaginatedTableWithContext';
import { TableSortingOrder, type SortOrderValue } from '../../../utilities/useSortAndFilterCache';

type SortRule = LabelsSortingRule & SortOrderValue;
type State = ExtendedPageState & {
    sort: SortRule;
    filter: LabelsFilteringField;
};

export type SetFilterAction = { type: 'setFilter'; filter: LabelsFilteringField };
export type SetSortAction = { type: 'setSort'; sortBy: SortRule };

export type Action = ExtendedPageAction | SetFilterAction | SetSortAction;

const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        case 'setFilter':
            return { ...state, page: 1, filter: action.filter };

        case 'setSort':
            return { ...state, page: 1, sort: action.sortBy };

        case 'setPage':
            return { ...state, page: action.page };

        case 'setPageSize':
            return { ...state, pageSize: action.pageSize };

        default:
            return extendedReducer(state, action);
    }
};

const useListReducer = (cache?: State) =>
    useReducer(reducer, {
        companyId: cache?.companyId,
        page: cache?.page || 1,
        pageSize: cache?.pageSize || 10,
        sort: cache?.sort || {
            field: LabelsSortingField.Identifier,
            order: SortingOrder.Desc,
            orderValue: TableSortingOrder.Desc,
        },
        filter: cache?.filter || {},
    });

export default useListReducer;
